package world.phantasmal.web.questEditor.widgets

import world.phantasmal.web.questEditor.rendering.QuestRenderer

class QuestEditorRendererWidget(
    renderer: QuestRenderer,
) : QuestRendererWidget(renderer)
